import {
  useSuspenseQuery,
  type UseSuspenseQueryOptions,
} from '@tanstack/react-query';
import type { GetStreamConfigResponse } from 'generated/openapi';

import {
  getStreamConfigKey,
  getStreamConfigOptions,
} from './getStreamConfig.options';

export interface UseGetStreamConfigProps<T = GetStreamConfigResponse> {
  options?: Omit<
    UseSuspenseQueryOptions<GetStreamConfigResponse, unknown, T>,
    'queryKey' | 'queryFn'
  >;
}

export function useGetStreamConfig<T = GetStreamConfigResponse>(
  props: UseGetStreamConfigProps<T> = {},
) {
  const { options } = props;

  return useSuspenseQuery({
    ...getStreamConfigOptions<T>(),
    ...options,
  });
}

useGetStreamConfig.getQueryKey = getStreamConfigKey;
